export const colors = [
  'rgb(97, 221, 169)',
  'rgb(91, 144, 249)',
  'rgb(246, 189, 20)',
  'rgb(252, 236, 185)',
  'rgb(114, 98, 253)',
  'rgb(120, 211, 248)',
  'rgb(150, 96, 188)'
]

// 字体粗细
export const fontWeightOpts = [
  { label: '细', value: 'lighter' },
  { label: '普通', value: 'normal' },
  { label: '较粗', value: 'bold' },
  { label: '粗', value: 'bolder' }
]

// 对齐方式
export const textAlignOpts = [
  { label: '左对齐', value: 'left' },
  { label: '居中对齐', value: 'center' },
  { label: '右对齐', value: 'right' }
]

// 日期格式
export const momentFormatTypeOpts = [
  { label: '日期+时分秒', value: 'YYYY/MM/DD HH:mm:ss' },
  { label: '日期+时分', value: 'YYYY/MM/DD HH:mm' },
  { label: '日期+星期', value: 'YYYY/MM/DD dddd' },
  { label: '日期', value: 'YYYY/MM/DD' },
  { label: '时分秒', value: 'HH:mm:ss' },
  { label: '时分', value: 'HH:mm' },
  { label: '星期', value: 'dddd' }
]

// 显示位置
export const positionOpts = (picker) => {
  const allOpts = [
    {
      value: 'top',
      label: 'top'
    },
    {
      value: 'top-left',
      label: 'top-left'
    },
    {
      value: 'top-right',
      label: 'top-right'
    },
    {
      value: 'right',
      label: 'right'
    },
    {
      value: 'right-top',
      label: 'right-top'
    },
    {
      value: 'right-bottom',
      label: 'right-bottom'
    },
    {
      value: 'left',
      label: 'left'
    },
    {
      value: 'left-top',
      label: 'left-top'
    },
    {
      value: 'left-bottom',
      label: 'left-bottom'
    },
    {
      value: 'bottom',
      label: 'bottom'
    },
    {
      value: 'bottom-left',
      label: 'bottom-left'
    },
    {
      value: 'bottom-right',
      label: 'bottom-right'
    }
  ]
  if (picker && picker.length) {
    return allOpts.filter((it) => picker.includes(it.value))
  }
  return allOpts
}

export const axisPositionOpts = [
  {
    value: 'start',
    label: 'start'
  },
  {
    value: 'center',
    label: 'center'
  },
  {
    value: 'end',
    label: 'end'
  }
]

// 布局layout
export const layoutOpts = [
  {
    value: 'horizontal',
    label: '水平方向'
  },
  {
    value: 'vertical',
    label: '垂直方向'
  }
]

// 折线上点的形状
export const pointShapeOpts = [
  {
    label: 'circle',
    value: 'circle'
  },
  {
    label: 'square',
    value: 'square'
  },
  {
    label: 'bowtie',
    value: 'bowtie'
  },
  {
    label: 'diamond',
    value: 'diamond'
  },
  {
    label: 'hexagon',
    value: 'hexagon'
  },
  {
    label: 'triangle',
    value: 'triangle'
  },
  {
    label: 'triangle-down',
    value: 'triangle-down'
  },
  {
    label: 'cross',
    value: 'cross'
  },
  {
    label: 'tick',
    value: 'tick'
  },
  {
    label: 'plus',
    value: 'plus'
  },
  {
    label: 'hyphen',
    value: 'hyphen'
  },
  {
    label: 'line',
    value: 'line'
  }
]
